import {
  TextField,
} from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';
import { useTranslation } from '@gamiphy/react-i18n';
import { Control, Controller } from 'react-hook-form';
import { UserInfoFormValues } from './types';

const NameField: React.FC<{control: Control<UserInfoFormValues>}> = ({ control }) => {
  const { t } = useTranslation();

  return (
    <Controller
      name="name"
      control={control}
      render={({
        field: {
          value,
          onChange,
        },
      }) => (
        <TextField
          variant="standard"
          placeholder={t('campaigns.boosters.referral.name.label', 'Full name')}
          value={value ?? ''}
          onChange={onChange}
          InputProps={{
            disableUnderline: true,
            sx: {
              bgcolor: '#E5E5E5',
              py: 1,
              px: 2,
              borderRadius: 0.5,
              fontSize: 16,
            },
            inputProps: {
              sx: {
                '&::placeholder': {
                  fontSize: '1.5rem',
                },
              },
            },
          }}
        />
      )}
    />

  );
};

export default observer(NameField);
